import { render, staticRenderFns } from "./gallery_dec.vue?vue&type=template&id=fea399ba&scoped=true&"
import script from "./gallery_dec.vue?vue&type=script&lang=js&"
export * from "./gallery_dec.vue?vue&type=script&lang=js&"
import style0 from "./gallery_dec.vue?vue&type=style&index=0&id=fea399ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea399ba",
  null
  
)

export default component.exports